import React, { Fragment, useRef } from 'react';
import { translate } from '../Services/translation';
import uuid4 from "uuid4";

const NavigationItem = ({ links = [], contentLink = null, helpDeskUrl = "", addressInformation = "", ChannelsNamesAndUrls = [], configuratorLink = "", configuratorOpenMode = "", renderMobileItems }) => {
    const menuRef = useRef(null);
    const toggleMenu = () => {
        menuRef.current.classList.toggle('navbar__menu--show');
    };
    const additionClass =
        contentLink && contentLink.attributes
            ? contentLink.attributes.cssValue
            : null;
    const selectedClass =
        contentLink && contentLink.isSelected ? 'navbar__link--selected' : '';
    const hasChildrenClass = links.length > 0 ? 'has-children' : null;
    const hasNameOrChildren = (link) =>
        link.name || (link.links || []).length > 0;

    const renderHTML = (rawHTML) => React.createElement("div", { dangerouslySetInnerHTML: { __html: rawHTML } });

    var channelsListItems;
    if (ChannelsNamesAndUrls) {
        channelsListItems = ChannelsNamesAndUrls.map((channel) =>
            <a href={channel.url} key={uuid4()}> {channel.name}</a>
        );
    }

    var helpDeskLink;
    if (helpDeskUrl != "") {
        helpDeskLink = <li key={uuid4()} className="navbar__item">
            <div className="mobileCountrySelector">
                <a className="navbar__link right-menu-text-mobile" href={helpDeskUrl || '#'}> {translate('megamenu.helpdesk.text')} <img className='right-menu-icon' src="/ui/images/contact.svg"></img> </a>
            </div>
        </li>;
    }

    var addressInformationBox;
    if (addressInformation != "") {
        addressInformationBox = <li key={uuid4()} className="navbar__item_addressinformation right-menu-text" dangerouslySetInnerHTML={{ __html: addressInformation }}></li>
    }

    return (
        <Fragment>
            {!contentLink ? (
                <a
                    className="navbar__link--block navbar__icon--menu navbar__icon"
                    onClick={toggleMenu}
                ></a>
            ) : (
                <Fragment>
                    <a
                        className={`navbar__link ${selectedClass} ${hasChildrenClass || ''
                            } ${additionClass || ''}`}
                        href={contentLink.url || '#'}
                        dangerouslySetInnerHTML={{ __html: contentLink.name }}
                    ></a>
                    {links.length > 0 && (
                        <i
                            className="navbar__icon--caret-right navbar__icon navbar__icon--open"
                            onClick={toggleMenu}
                        ></i>
                    )}
                </Fragment>
            )}

            {links.length > 0 && (
                <ul className="navbar__menu" ref={menuRef}>
                    <li key={uuid4()}>
                        <div className="navbar__menu-header">
                            {!contentLink ? (
                                <span
                                    className="navbar__icon navbar__icon--close"
                                    onClick={toggleMenu}
                                ></span>
                            ) : (
                                <Fragment>
                                    <i
                                        className="navbar__icon--caret-left navbar__icon"
                                        onClick={toggleMenu}
                                    ></i>
                                    <span
                                        className="navbar__title"
                                        onClick={toggleMenu}
                                        dangerouslySetInnerHTML={{
                                            __html: contentLink.name,
                                        }}
                                    ></span>
                                </Fragment>
                            )}
                        </div>
                    </li>
                    {links.length > 0 &&
                        links.map((link, i) => {
                            return hasNameOrChildren(link) && (
                                <li key={uuid4()} className="navbar__item">
                                    <NavigationItem
                                        key={uuid4()}
                                        links={link.links}
                                        contentLink={link}
                                    />
                                </li>
                            )
                        }
                        )}
                    {renderMobileItems && <>
                        {helpDeskLink}
                        {configuratorLink.Url != null ?
                            <li key={uuid4()} className="navbar__item">
                                <a className="navbar__link right-menu-text-mobile" href={configuratorLink.Url || '#'}> {configuratorLink.Text ? configuratorLink.Text : "Configurator"}
                                    <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 400 400">
                                        <path className="cls-2" d="M200.8,314.88h-37.66v-16.56c0-13.55-7.93-24.62-18.45-32.08-25.59-18.16-42.75-47.62-42.75-81.38,0-54.59,44.26-98.85,98.85-98.85s98.85,44.26,98.85,98.85c0,33.75-17.15,63.22-42.75,81.38-10.51,7.46-18.45,18.53-18.45,32.08v16.56h-37.66Z" />
                                        <path className="cls-1" d="M237.41,152.64v34.68c.01,1.99-2.62,2.7-3.62.98l-20.71-35.66h-24.4s.01,34.68.01,34.68c0,1.99-2.63,2.7-3.63.98l-20.71-35.66h-24.35v41.93l24.35,41.93h24.35v-34.82c.12-1.88,2.64-2.53,3.62-.85l20.71,35.66h24.35l24.38-41.93v-41.93h-24.35Z" />
                                        <path className="cls-2" d="M163.14,314.88h75.28v37.23c0,1.1-.9,2-2,2h-71.26c-1.11,0-2.01-.9-2.01-2.01v-37.22h0Z" />
                                        <path className="cls-2" d="M185.56,354.12v5.85c0,8.54,6.92,15.46,15.46,15.46s15.46-6.92,15.46-15.46v-5.85" />
                                        <line className="cls-2" x1="201.05" y1="11.43" x2="201.05" y2="54.43" />
                                        <line className="cls-2" x1="357.51" y1="104.1" x2="320.27" y2="125.6" />
                                        <line className="cls-2" x1="320.27" y1="248.4" x2="357.51" y2="269.9" />
                                        <line className="cls-2" x1="42.49" y1="269.9" x2="79.73" y2="248.4" />
                                        <line className="cls-2" x1="85.59" y1="118.01" x2="48.35" y2="96.51" />
                                    </svg>
                                </a>
                            </li> : null}
                        <li key={uuid4()} className="navbar__item">
                            <div className="dropdown__mobile">
                                <div>
                                    <p onClick={() => {
                                        document.getElementById("country__selector__dropdown__mobile").classList.toggle("show__list__mobile");

                                    }} className="navbar__link right-menu-text-mobile selector__dropdown__mobile">{translate('megamenu.countryselector.text')} <img className='right-menu-icon' src="/ui/images/earth.svg"></img></p>
                                </div>
                                <div id="country__selector__dropdown__mobile" className="selector__list">
                                    {channelsListItems}
                                </div>
                            </div>
                        </li>
                        {addressInformationBox}</>
                    }
                </ul>
            )
            }
        </Fragment >
    );
};

export default NavigationItem;
